import React from 'react'
import './RatingStars.css'

function ratingStars(rating: number) {
  let stars = ''
  let fullStars = Math.floor(rating)
  let halfStars =
    0 < Math.round(rating) - Number(rating.toFixed(2)) &&
    Math.round(rating) - Number(rating.toFixed(2)) < 0.5
      ? 1
      : 0
  let emptyStars = 5 - fullStars - halfStars

  for (let i = 0; i < fullStars; i++) {
    stars += `<span class="cocunat-fullStar">★</span>`
  }
  for (let i = 0; i < halfStars; i++) {
    stars += `<span class="cocunat-halfStar">★</span>`
  }
  for (let i = 0; i < emptyStars; i++) {
    stars += `<span class="cocunat-emptyStar">★</span>`
  }

  return stars
}

type RatingStarsProps = {
  rating: number
  size?: number
}

function RatingStars({ rating, size = 19 }: RatingStarsProps) {
  return (
    <span
      style={{ fontSize: `${size}px` }}
      dangerouslySetInnerHTML={{
        __html: `${ratingStars(rating)}`
      }}
    />
  )
}

export default RatingStars
